import {shallowEqual, useSelector} from 'react-redux'

const currentUserSelector = state => state.authentication
export default function useCurrentUser() {
  const currentUser = useSelector(currentUserSelector, shallowEqual)
  return { ...currentUser }
}
